module.exports = __webpack_public_path__ + "img/frame-test-l.14e18dda.png";